export const REQUEST_REPORT_DATA = 'REQUEST_REPORT_DATA';
export const SET_REPORT_DATA = 'SET_REPORT_DATA';
export const UPDATE_REPORT_INITIAL_PARAMS = 'UPDATE_REPORT_INITIAL_PARAMS';
export const CACHE_REPORT_DATA = 'CACHE_REPORT_DATA';
export const SET_CACHE_DATA = 'SET_CACHE_DATA';

export const RESET_REPORT_TABLE_REDUCER = 'RESET_REPORT_TABLE_REDUCER';
export const SET_IS_REQUESTING_DATA = 'SET_IS_REQUESTING_DATA';
